import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useTypewriter } from "@/lib/useTypewriter";
import { QUESTIONS } from "@/components/candidati/sim/simData";

const Answers = ({ question, order, selected, done, onAnswer }) => (
  <div className={`mt-6 grid gap-3 transition-opacity duration-300 ${done ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
    {order.map((orig, i) => (
      <button
        key={orig}
        type="button"
        onClick={() => onAnswer(orig)}
        tabIndex={done ? 0 : -1}
        aria-pressed={selected === orig}
        className="sim-answer group flex items-start gap-4 rounded-xl border border-[#1e2024] bg-white/[0.02] px-4 py-3.5 text-left text-sm sm:text-[15px] text-white/90"
        data-testid={`sim-answer-${i + 1}`}
      >
        <span className="font-mono text-cyan shrink-0">[{i + 1}]</span>
        {question.answers[orig].label}
      </button>
    ))}
  </div>
);

export const SimQuestion = ({ index, order, selected, onAnswer, onBack }) => {
  const question = QUESTIONS[index];
  const total = QUESTIONS.length;
  const [typed, done] = useTypewriter(question.text, 14, selected !== undefined);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.key === "Backspace" || e.key === "ArrowLeft") && index > 0) {
        e.preventDefault();
        onBack();
        return;
      }
      const k = Number(e.key);
      if (done && k >= 1 && k <= 4) onAnswer(order[k - 1]);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [done, index, order, onAnswer, onBack]);

  return (
    <div className="sim-step" data-testid={`sim-question-${index + 1}`}>
      <div className="flex items-center justify-between gap-3 font-mono text-xs text-titanium">
        <span data-testid="sim-progress-label">Domanda {index + 1}/{total}</span>
        <span className="hidden sm:inline text-[#5b6068]">prodigy@terminal:~$ analisi --step {index + 1}</span>
      </div>
      <div className="mt-3 h-[3px] rounded-full bg-white/[0.06] overflow-hidden">
        <div className="h-full bg-[#00e5ff] shadow-[0_0_10px_#00e5ff] transition-[width] duration-500" style={{ width: `${((index + 1) / total) * 100}%` }} data-testid="sim-progress-bar" />
      </div>
      <p className="mt-8 min-h-[84px] font-mono text-base sm:text-lg leading-relaxed text-white" data-testid="sim-question-text">
        <span className="text-cyan">&gt; </span>
        {typed}
        {!done && <span className="anim-blink ml-0.5 inline-block h-4 w-2 translate-y-0.5 bg-[#00e5ff]" />}
      </p>
      <Answers question={question} order={order} selected={selected} done={done} onAnswer={onAnswer} />
      <div className="mt-5 flex items-center justify-between gap-4">
        {index > 0 ? (
          <button type="button" onClick={onBack} className="nav-link flex items-center gap-2 font-mono text-xs text-titanium hover:text-white" data-testid="sim-back">
            <ArrowLeft className="h-3.5 w-3.5" /> Indietro
          </button>
        ) : <span />}
        <p className="hidden sm:block font-mono text-[11px] text-[#5b6068]">Premi 1-4 per rispondere · ← per tornare indietro</p>
      </div>
    </div>
  );
};
